var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible_spinner)?_c('div',{staticClass:"main-blur-spinner"},[_c('div',{staticClass:"loading-text-under"},[_vm._v(_vm._s(_vm.loadingText))]),_c('div',[_c('svg',{staticClass:"dot-spin",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }